"use client";

import { ProductsConsumer } from "@/app/products/store";
import { SEARCH_PAGE_LIMIT } from "@/data/search";
import { type Product } from "@repo/schemas";
import { Paginator } from "../blocks/Paginator";
import { ProductCard } from "../blocks/ProductCard";
import { ProductsHeaderContainer } from "./ProductsHeaderContainer";

export function ProductsContainer() {
  return (
    <div className="m-auto max-w-[1440px] animate-[fadeIn_0.5s_ease-in-out] px-4 py-4 lg:px-8 2xl:px-0">
      <ProductsHeaderContainer />
      <ProductsConsumer getters={["products"]}>
        {({ products }) =>
          products.length === 0 ? <div>No products</div> : <ProductsGrid products={products} />
        }
      </ProductsConsumer>
      <ProductsConsumer getters={["totalNbOfProducts", "productsSearchParams"]}>
        {({ totalNbOfProducts }) => (
          <Paginator totalNbOfItems={totalNbOfProducts} nbOfItemsPerPage={SEARCH_PAGE_LIMIT} />
        )}
      </ProductsConsumer>
    </div>
  );
}

function ProductsGrid({ products }: { products: Product[] }) {
  return (
    <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {products.map((product) => (
        <li key={product.id}>
          <ProductCard product={product} />
        </li>
      ))}
    </ul>
  );
}
